import { HttpInterceptorFn, HttpEventType } from "@angular/common/http";
import { tap } from "rxjs";

// Improve logging: include method, masked Authorization header and detailed error output for easier debugging
export const LoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const startTime = Date.now();

  // Mask Authorization header for safe logging (avoid accessing headers to prevent null.toString issues)
  const maskedAuth = 'none';

  return next(req).pipe(
    tap({
      next: (event: any) => {
        if (event.type === HttpEventType.Response && event.status >= 400) {
          const duration = Date.now() - startTime;
          console.warn(`HTTP ${event.status} response in ${duration}ms: ${req.method} ${req.url}`, {
            status: event.status,
            method: req.method,
            url: req.url,
            auth: maskedAuth
          });
        }
      },
      error: (error: any) => {
        const duration = Date.now() - startTime;
        const status = error && error.status ? error.status : 'unknown';
        const message = error?.message || (error?.error && typeof error.error === 'string' ? error.error : JSON.stringify(error?.error ?? error)) || 'no-message';
        console.error(`Request failed after ${duration}ms: ${req.method} ${req.url} ${status}`, {
          status,
          method: req.method,
          url: req.url,
          message,
          auth: maskedAuth
        });
      }
    })
  );
}